"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactPaginate = _interopRequireDefault(require("react-paginate"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Pagination, _PureComponent);

  function Pagination() {
    (0, _classCallCheck2["default"])(this, Pagination);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Pagination).apply(this, arguments));
  }

  (0, _createClass2["default"])(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          pagesOutsideElipses = _this$props.pagesOutsideElipses,
          pagesBetweenElipses = _this$props.pagesBetweenElipses,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["pagesOutsideElipses", "pagesBetweenElipses"]);
      return _react["default"].createElement(_reactPaginate["default"], (0, _extends2["default"])({
        marginPagesDisplayed: pagesOutsideElipses,
        pageRangeDisplayed: pagesBetweenElipses,
        previousLabel: '<',
        nextLabel: '>',
        breakLabel: "...",
        containerClassName: "pagination",
        pageClassName: "pageNumber",
        activeClassName: "active pageNumber",
        previousClassName: "arrow",
        nextClassName: "arrow",
        breakClassName: "ellipses"
      }, rest));
    }
  }]);
  return Pagination;
}(_react.PureComponent);

exports["default"] = Pagination;
Pagination.propTypes = {
  initialPage: _propTypes["default"].number,
  pagesOutsideElipses: _propTypes["default"].number,
  pagesBetweenElipses: _propTypes["default"].number
};
Pagination.defaultProps = {
  initialPage: 0,
  pagesOutsideElipses: 1,
  pagesBetweenElipses: 3
};